import { defineMessages } from 'react-intl';

const translations = {
  dateOptions: {
    today: {
      id: 'dateOptions.today',
      defaultMessage: 'Today',
      description: 'Label of the date option today',
    },
    relativeNow: {
      id: 'dateOptions.relativeNow',
      defaultMessage: 'Relative from now',
      description: 'Label of the date option relative now',
    },
    relative: {
      id: 'dateOptions.relative',
      defaultMessage: 'Relative from date / time',
      description: 'Label of the date option relative',
    },
    date: {
      id: 'dateOptions.date',
      defaultMessage: 'Date',
      description: 'Label of the date option date',
    },
  },
};

export default defineMessages(translations);
